import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ServiceAgreementCompany } from 'ogp/services/service-agreements.schema';
import { translateRoleToDutch } from 'shared/utils/roles-utils';

type CompanyUsersProps = {
  users: ServiceAgreementCompany['users'];
};

export const CompanyUsers = ({ users }: CompanyUsersProps) => {
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <Table
      aria-label={t('collegial-lending.customers.detail.users.aria-label', {
        defaultValue: 'Gebruikers van het bedrijf',
      })}
    >
      <TableHead>
        <TableRow>
          <TableCell>
            {t('collegial-lending.customers.detail.users.user.label', {
              defaultValue: 'Gebruiker',
            })}
          </TableCell>
          <TableCell>
            {t('collegial-lending.customers.detail.users.phone.label', {
              defaultValue: 'Telefoonnummer',
            })}
          </TableCell>
          <TableCell>
            {t('collegial-lending.customers.detail.users.email.label', { defaultValue: 'E-mail' })}
          </TableCell>
          <TableCell>
            {t('collegial-lending.customers.detail.users.role.label', { defaultValue: 'Rol' })}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {users.map((user) => (
          <TableRow key={user.id}>
            <TableCell>{`${user.firstName} ${user.lastName}`}</TableCell>
            <TableCell>{user.phone || '-'}</TableCell>
            <TableCell>{user.email}</TableCell>
            <TableCell>{user.role ? translateRoleToDutch(user.role) : '-'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
